// extracted by mini-css-extract-plugin
export default {"wrapper":"premium_wrapper_YVxgw","background":"premium_background_afRrJ","main":"premium_main_Ehgvb","childView":"premium_childView_zG6eM"};